// extracted by mini-css-extract-plugin
export default {"menu":"t71ka","menuOpen":"UYmgr","nav":"xpJGr","navItem":"Ghbcy","navItemSelected":"v7t9Z","navLink":"hGU7S","header":"qymEW","text":"MqCtv","caption":"QhILG","logout":"EatXS"};